function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function extractPlaceholders(value) {
  const matches = String(value ?? "").match(/{{\s*[^}]+\s*}}/g) || [];
  return [...new Set(matches)];
}

function serializeLeaf(value) {
  if (typeof value === "string") {
    return { value, valueType: "string" };
  }
  if (typeof value === "number") {
    return { value: String(value), valueType: "number" };
  }
  if (typeof value === "boolean") {
    return { value: value ? "true" : "false", valueType: "boolean" };
  }
  if (value === null) {
    return { value: "", valueType: "null" };
  }
  return { value: JSON.stringify(value, null, 2), valueType: "json" };
}

function parseLeaf(value, valueType) {
  if (valueType === "string") return value;

  if (valueType === "number") {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
      throw new Error("Числовое значение локали заполнено некорректно.");
    }
    return parsed;
  }

  if (valueType === "boolean") {
    const normalized = String(value).trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
    throw new Error("Булево значение локали должно быть true или false.");
  }

  if (valueType === "null") {
    const normalized = String(value).trim().toLowerCase();
    if (!normalized || normalized === "null") return null;
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (_) {
    throw new Error("JSON-значение локали заполнено некорректно.");
  }
}

export function flattenLocaleObject(source, parentSegments = []) {
  if (!isPlainObject(source)) return [];
  const entries = [];

  for (const [key, value] of Object.entries(source)) {
    const segments = [...parentSegments, key];

    if (isPlainObject(value) && Object.keys(value).length > 0) {
      entries.push(...flattenLocaleObject(value, segments));
      continue;
    }

    const serialized = serializeLeaf(value);
    entries.push({
      path: segments.join("."),
      group: segments[0] || "root",
      segments,
      key,
      value: serialized.value,
      valueType: serialized.valueType,
      placeholders: extractPlaceholders(serialized.value),
      multiline: String(serialized.value).includes("\n")
    });
  }

  return entries;
}

export function restoreLocaleObject(entries) {
  const result = {};

  for (const entry of entries) {
    let cursor = result;
    const lastIndex = entry.segments.length - 1;

    entry.segments.forEach((segment, index) => {
      if (index === lastIndex) {
        cursor[segment] = parseLeaf(entry.value, entry.valueType);
        return;
      }

      if (!isPlainObject(cursor[segment])) {
        cursor[segment] = {};
      }

      cursor = cursor[segment];
    });
  }

  return result;
}
